export const QUERY_KEY_LISTS = "basket__CustomArticleLists"
export const QUERY_KEY_ARTICLES = "basket__CustomArticles"
export const DEFAULTS_KEY = "basket____CustomArticlesDefaults"
